import { memo, useCallback } from 'react'
import type { NamedExoticComponent, PropsWithChildren } from 'react'
import { useIntl } from 'umi'

import cn from 'classnames'
import Button from '@salesforce/design-system-react/components/button'
import styles from './index.less'

const variantMap = {
  default: '/imgs/empty.png',
  task: '/assets/images/illustrations/empty-state-tasks.svg',
  available: '/assets/images/illustrations/empty-state-not-available-in-lightning.svg',
  result: '/assets/images/illustrations/empty-state-no-results.svg',
  access: '/assets/images/illustrations/empty-state-no-access.svg',
  event: '/assets/images/illustrations/empty-state-events.svg',
  assistant: '/assets/images/illustrations/empty-state-assistant.svg',
}

type IEmptyImgVariant = keyof typeof variantMap

interface IPlaceholderProps {
  msg?: ReactNode
  subMsg?: ReactNode
  btnName?: IntlTextType
  handleClick?: () => void
  className?: string
  wrapperClassName?: string
  align?: boolean
  hightLess?: boolean
  size?: 'small' | 'medium' | 'large'
  imgSrc?: string
  variant?: IEmptyImgVariant
}

const Placeholder: NamedExoticComponent<PropsWithChildren<IPlaceholderProps>> = memo((props) => {
  const intl = useIntl()

  const {
    msg = '',
    subMsg,
    handleClick,
    btnName = intl.messages['Global.retry'],
    className,
    wrapperClassName,
    align,
    hightLess,
    size,
    imgSrc,
    variant = 'default',
  } = props

  const src = imgSrc || variantMap[variant]

  const handleBtnClick = useCallback(() => {
    handleClick?.()
  }, [handleClick])

  return (
    <div
      className={cn(styles['place-container'], wrapperClassName, {
        [styles[`size-${size}`]]: !!size,
        [styles['vertical-center']]: align,
        [styles['hight-less']]: hightLess,
      })}
    >
      <img src={src} className={styles['place-container__img']} alt="" />
      <p className={styles['place-container__text']}>{msg || 'Page not found'}</p>
      {subMsg && <p className={styles['place-container__sub-msg']}>{subMsg}</p>}
      {handleClick && (
        <div className={styles['place-container__btn-wrap']}>
          <Button variant="brand" onClick={handleBtnClick}>
            {btnName}
          </Button>
        </div>
      )}
      <div className={className}>{props.children}</div>
    </div>
  )
})

export type { IPlaceholderProps }

export { styles as PlaceholderStyle }

export default Placeholder
